import { VLayout } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('TitlePage',{attrs:{"title":_vm.$t('test')+' '+_vm.$t('booking')}}),_c(VLayout,{attrs:{"wrap":""}},[_c('p',[_vm._v("Success")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }